"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "senigallia": {
    "7c93a9e0": [{
      "hkey": "5d4f6179",
      "slug": "cesano",
      "name": "Cesano",
      "primary": true,
      "skipSearch": false
    }],
    "cesano-bruciata": [{
      "hkey": "5d4f6179",
      "slug": "cesano",
      "name": "Cesano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "senigallia"
    }],
    "4642f6b0": [{
      "hkey": "7e304306",
      "slug": "saline",
      "name": "Saline",
      "primary": true,
      "skipSearch": false
    }],
    "ciarnin": [{
      "hkey": "7e304306",
      "slug": "saline",
      "name": "Saline",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d50fb56a": [{
      "hkey": "2f950d71",
      "slug": "montignano-marzocca",
      "name": "Montignano-Marzocca",
      "primary": true,
      "skipSearch": false
    }],
    "marzocca": [{
      "hkey": "2f950d71",
      "slug": "montignano-marzocca",
      "name": "Montignano-Marzocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "senigallia"
    }],
    "6dbe38a0": [{
      "hkey": "2f950d71",
      "slug": "montignano-marzocca",
      "name": "Montignano-Marzocca",
      "primary": true,
      "skipSearch": false
    }],
    "montignano": [{
      "hkey": "2f950d71",
      "slug": "montignano-marzocca",
      "name": "Montignano-Marzocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a3412b84": [{
      "hkey": "bf0381ce",
      "slug": "senigallia",
      "name": "Senigallia",
      "primary": true,
      "skipSearch": false
    }],
    "san-silvestro": [{
      "hkey": "bf0381ce",
      "slug": "senigallia",
      "name": "Senigallia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;